import React from 'react';
import { Modal } from 'antd';
import Icon from 'antd/es/icon';

const CloseIcon = <Icon type="close" className="text-gray-600" />;

const DSModal = ({
  title,
  footer,
  children,
  wrapClassName = '',
  className = '',
  width = 480,
  maskClosable = true,
  closable = true,
  ...rest
}) => (
  <Modal
    {...rest}
    title={<span className="text-ts-xl font-fig-semibold text-gray-900">{title}</span>}
    footer={footer}
    width={width}
    maskClosable={maskClosable}
    closable={closable}
    closeIcon={CloseIcon}
    wrapClassName={`ds-modal-wrap ${wrapClassName}`.trim()}
    className={`ds-modal ${className}`.trim()}
    bodyStyle={{ paddingTop: 16, fontSize: 15, lineHeight: 1.6, color: '#4B5563' }}
  >
    {children}
  </Modal>
);

export default DSModal;
